import { Button, Card, Col, Container, Row } from "react-bootstrap";
import CoursePlan from "../../docs/RDL7702CourseOutline.pdf";
import Background from "../../image/bg3.jpg";

export default function ArtisanalProduction() {
    return(
    <>
    <Container fluid style={{background: "url(" + Background + ") no-repeat fixed center"}}>
    <Container>
        <Row className="justify-content-center section">
            <Col md="8" sm="12" className="image-over-section">
                <h2 style={{textAlign:"center"}}>Traditional Artisanal Production in India (RDL7702)</h2>
                <p style={{textAlign:"center"}}>(Previously RDL702 Karigar and Traditional Industries)</p>
                <Button href={CoursePlan} target="_blank">Course plan <i className="bi bi-box-arrow-up-right"></i></Button>
            </Col>
        </Row>
    </Container>
    </Container>

    <Container className="section">

                <h2 style={{paddingTop:"30px"}}>Course Learning Outcomes</h2>
        <Row xs="1" sm="3" md="3">
            <Col>
                <Card className="publications-list module">
                    <Card.Body>
                        <Card.Text>
                            CLO 1: Appreciate the history, philosophy, and socio-cultural significance of traditional artisanal knowledge systems in India
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>

            <Col>
                <Card className="publications-list module">
                    <Card.Body>
                        <Card.Text>
                            CLO 2: Analyze materiality, processes, and aesthetic values embedded in artisanal production
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>
            <Col>
                <Card className="publications-list module">
                    <Card.Body>
                        <Card.Text>
                            CLO 3: Develop a critical lens to evaluate contemporary challenges and opportunities for artisans in the modern economy. 
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>

            <Col>
                <Card className="publications-list module">
                    <Card.Body>
                        <Card.Text>
                           CLO 4: Engage directly with artisans to co-learn skills, methods, and values through hands-on, experiential methods
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>

            <Col>
                <Card className="publications-list module">
                    <Card.Body>
                        <Card.Text>
                            CLO 5: Apply insights from design thinking and business innovation to propose context-sensitive solutions for the revitalization of artisanal practices.
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>
            
        </Row>



            <h2 style={{paddingTop:"30px"}}>14 Discussion Based Modules (In Person)</h2>
        <Row xs="1" sm="3" md="3">
            <Col>
                <Card className="publications-list module">
                    <Card.Body>
                        <Card.Text>
                            Module 1: Introduction to Indian Artisanal Traditions : An Overview (3.00 Hrs)
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>

            <Col>
                <Card className="publications-list module">
                    <Card.Body>
                        <Card.Text>
                            Module 2: Historical and Cultural Contexts of Artisanal Production (3.00 Hrs)
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>
            <Col>
                <Card className="publications-list module">
                    <Card.Body>
                        <Card.Text>
                            Module 3: Indigenous Materials and Sustainable Techniques : Wood, Metal, Clay, Stone, Fabric and Color (3.00 Hrs)
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>

            <Col>
                <Card className="publications-list module">
                    <Card.Body>
                        <Card.Text>
                            Module 4: Knowledge Systems and Role of Community Learning (3.00 Hrs)
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>

            <Col>
                <Card className="publications-list module">
                    <Card.Body>
                        <Card.Text>
                            Module 5: Craft and Aesthetics : Indian Theories of Beauty (Rasa, Bhava and Auchitya) (3.00 Hrs)
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>

            <Col>
                <Card className="publications-list module">
                    <Card.Body>
                        <Card.Text>
                            Module 6: Tools, Techniques, and Rhythms of Making (3.00 Hrs)
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>

            <Col>
                <Card className="publications-list module">
                    <Card.Body>
                        <Card.Text>
                            Module 7: Sustainability, Ecology, and Zero-Waste in Traditional Craft	(3.00 Hrs)
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>

            <Col>
                <Card className="publications-list module">
                    <Card.Body>
                        <Card.Text>
                        Module 8: Artisanal Economies : Trade, Guilds, Markets (Ancient to Modern) (3.00 Hrs)</Card.Text>
                    </Card.Body>
                </Card>
            </Col>

            <Col>
                <Card className="publications-list module">
                    <Card.Body>
                        <Card.Text>
                            Module 9: Colonial Impact and Post-Independence Revivals (3.00 Hrs)
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col> 

            <Col>
                <Card className="publications-list module">
                    <Card.Body>
                        <Card.Text>
                            Module 10: Intellectual Property & GI Tags in Traditional Knowledge (3.00 Hrs)
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>
            <Col>
                <Card className="publications-list module">
                    <Card.Body>
                        <Card.Text>
                            Module 11: Design Thinking for the Artisanal Sector : Co-Creation and Innovation (3.00 Hrs)
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>
            <Col>
                <Card className="publications-list module">
                    <Card.Body>
                        <Card.Text>
                            Module 12: Policy, Livelihoods & Digital Access for Artisans (3.00 Hrs)
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>
            <Col>
                <Card className="publications-list module">
                    <Card.Body>
                        <Card.Text>
                            Module 13: Craft and Gender : Roles, Agency, and Representation (3.00 Hrs)
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>
            <Col>
                <Card className="publications-list module">
                    <Card.Body>
                        <Card.Text>
                            Module 14: Course Summary and Personal Reflections on Course Journey (3.00 Hrs)
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>
            
        </Row>



        <h2 style={{paddingTop:"30px"}}>Practice Based Activities (including time for assessments and submissions)</h2>
        <Row xs="1" sm="3" md="3">
            <Col>
                <Card className="publications-list module">
                    <Card.Body>
                        <Card.Text>
                            Practical Module 1 : Immersion, Observations and Interactions with an Artisanal Community (24 hrs including time for submissions : 8 + 16 hrs)
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>

            <Col>
                <Card className="publications-list module">
                    <Card.Body>
                        <Card.Text>
                            Practical Module 2 : Exploration and Co-Framing of New Opportunity Pathways with Artisanal Communities(24 hrs including the time for submissions : 6 + 18 hrs)
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>
            <Col>
                <Card className="publications-list module">
                    <Card.Body>
                        <Card.Text>
                            Practical Module 3 : Applying Design Thinking Approaches to Collaboratively Ideate Diverse Solution Pathways to overcome Challenges (32 hrs including the time for submissions : 8 + 24 hrs)
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>

            <Col>
                <Card className="publications-list module">
                    <Card.Body>
                        <Card.Text>
                           Practical Module 4 : Using Business Model Canvas & Value Proposition Canvas to propose new Technology - Business - Design approaches for Revitalization of Artisanal Clusters (32 hrs including the time for submissions : 6 + 36 hrs)
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>
            
        </Row>


        <Row>
            <Col sm="12" md="6">
                <h2 style={{paddingTop:"30px"}}>Self Study Components </h2>
                <ol>
                    <li>Ethnographic Immersion and Research Methods</li>
                    <li>Recording, Editing and Production of Audio-Video and</li>
                    <li>Creation of Blog, Website, App of outcomes and solutions for the artisanal sector.</li>
                </ol>
            </Col>
            <Col sm="12" md="6">
                <h2 style={{paddingTop:"30px"}}>Attendance Policy</h2>
                <p>75% Attendance or Above and Active Class Participation is Expected. For Audit Pass, Minimum 50% Attendance is required.</p>
            </Col>
        </Row>

        <h2 style={{paddingTop:"30px"}}>Evaluation Plan</h2>
        <Row xs="1" sm="3" md="3">
            <Col>
                <Card className="publications-list module">
                    <Card.Body>
                        <Card.Text>
                            Assessment 1 (10%) Well Researched Essay Submission based on study of Books and Monographs  : Study the works of Ananda K Coomaraswamy, Rabindranath Tagore, Kapila Vatsyayan and Kapil Kapur. Submit a well-researched 4000 word Essay containing contemporary socio-cultural significance of art in Indian context.
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>

            <Col>
                <Card className="publications-list module">
                    <Card.Body>
                        <Card.Text>
                            Assessment 2 (15%) Well Researched Presentation based on study of Books and Monographs : Study the works of M P Ranjan, Tirthankar Roy, Laila Tyabji and Jaya Jaitly and others Submit a well-researched 4000 word Essay containing contemporary socio-cultural significance of art in Indian context.
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>
            <Col>
                <Card className="publications-list module">
                    <Card.Body>
                        <Card.Text>
                            Assessment 3 (15%) Well Researched Essay Submission cum Presentation based on study of Books and Monographs : Study the works of Ritu Sethi, Radhika Singh and Ruchira Sinha and others . Submit a well-researched 4000 word Essay containing contemporary socio-cultural significance of art in Indian context.                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>

            <Col>
                <Card className="publications-list module">
                    <Card.Body>
                        <Card.Text>
                           Assessment 4 (20%) Group Presentation after Impactathon Part 1 - Immersive Field Visit to Artisanal Cluster	Immersive Field Visit, Community Interactions, Opportunity Identification
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>

            <Col>
                <Card className="publications-list module">
                    <Card.Body>
                        <Card.Text>
                           Assessment 5 (40%) Group Presentation after Impactathon Part 2 : Immersive Field Visit to Artisanal Cluster and Business Plan Creation	Analysis of Immersive Field Visit & Community Interactions, Opportunity Identification and Impact Plan Presentation using 7 Min Video Film 
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>
            
        </Row>

        <Row>
            <h2 style={{paddingTop:"30px"}}>Suggested Texts and Reference Materials</h2>

<Col><ol>
            <li>Coomaraswamy, Ananda K, The Arts and Crafts of India and Ceylon, Munshiram Manoharlal, New Delhi, ISBN 9788121506200 (2003)</li>

<li>Coomaraswamy, Ananda K, The Transformation of Nature in Art, Munshiram Manoharlal, New Delhi, ISBN 9788121509850 (2004)</li>

<li>Kapur, Kapil, Language, Aesthetics and Art : Indian and Western Poetics, D.K. Printworld, Delhi, ISBN 978812460979 (2020)</li>

<li>Roy, Tirthankar, Traditional Industry in the Economy of Colonial India, Cambridge University Press, ISBN 9780521650120	(1999)</li>

<li>Roy, Tirthankar, The Crafts and Capitalism in Colonial India, Routledge India, New Delhi, ISBN 9781032404943 (2023)</li>

<li>Jaitly, Jaya, Crafts Atlas of India, Niyogi Books, New Delhi, ISBN 9788189738430 (2012)</li>

<li> Sethi, Ritu (Ed.)	Craft Traditions of India, Mapin Publishing Ahmedabad & IGNCA, New Delhi, ISBN 978818820443 (2005)</li>

<li>Ranjan, M. P. and Ranjan, Aditi, Handmade in India: A Geographic Encyclopedia of Indian Handicrafts, Council of Handicraft Development Corporations (COHANDS) New Delhi & Mapin Publishing, Ahmedabad, ISBN 9788188204561 (2007)</li>

<li>Jain, Jyotindra, Kalighat Painting: Images from a Changing World, Mapin Publishing, New Delhi, ISBN 9780944142770 (1999)</li>

<li>Tyabji, Laila, Threads and Voices : Behind the Indian Textile Tradition, Marg Publications, Mumbai, ISBN 8185026785 (2007)</li>

<li>Tagore, Rabindranath, The Religion of Man	Reprint, Rupa Publications, ISBN 9788129115435	(2011)</li>

<li>Sivakumar, R. (Ed.)	Santiniketan: The Making of a Contextual Modernism, National Gallery of Modern Art, New Delhi (1997)</li>

<li>Vatsyayan, Kapila	Traditional Indian Theatre : Multiple Streams, National Book Trust ISBN 9788123721151 (1996)</li>

<li>Rao, K. Ramakrishna, Indian Psychology and Consciousness: A New Synthesis, Motilal Banarsidass, New Delhi, ISBN 9788120819370 (2002)</li>

<li>Sen, Amartya, The Argumentative Indian: Writings on Indian Culture, History and Identity	London: Penguin Books, ISBN 9780141012117	(2005)</li>

<li>Singh, Radhika, The Fabric of Our Lives: The Story of Fabindia, Penguin India, ISBN  9780670083731, (2010)</li>

<li> Nath, Aman and Wacziarg, Francis Arts and Crafts of Rajasthan, India Book House, Mumbai, ISBN 9788175082392	(2004)</li>

<li> Jain, Rahul, Rapture : The Art of Indian Textiles, Mapin Publishing, Ahmedabad, ISBN 9781890206580 (2006) </li>

<li>Sinha, Ruchira, Crafting a Livelihood: Women and Handicrafts in India, Zubaan	Books New Delhi, ISBN 9789385932110 (2017)</li>

<li>UNESCO India & Dastkar, Mapping India's Intangible Cultural Heritage, UNESCO India & Dastkar (2015)</li>

<li> Panda, Nandini Bhattacharya, Traditional Knowledge Systems in India	Delhi, D.K. Printworld & IGNCA, ISBN 9788124605887 (2010)</li>
</ol></Col>
        </Row>
    </Container>
    </>
    )
}